export interface SocialLinkConfig {
  id: "instagram" | "youtube" | "linkedin" | "telegram";
  label: string;
  href: string;
  order: number;
  ariaLabel?: string;
}

const socialLinks: SocialLinkConfig[] = [
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/luba__prohorovaconsult?igsh=MThhcWd5YmpldG80dA%3D%3D&utm_source=qr",
    order: 1,
    ariaLabel: "Instagram",
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://youtube.com/@lubovprohorovacareer?feature=shared",
    order: 2,
    ariaLabel: "YouTube",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/",
    order: 3,
    ariaLabel: "LinkedIn",
  },
  {
    id: "telegram",
    label: "Telegram",
    href: "https://t.me/+l1tXIWXd1RcwMDAy",
    order: 4,
    ariaLabel: "Telegram",
  },
];

export default socialLinks;
